export default "__VITE_ASSET__31355e02__"